import { render, staticRenderFns } from "./PdSection.vue?vue&type=template&id=8f15443e&scoped=true&"
import script from "./PdSection.vue?vue&type=script&lang=js&"
export * from "./PdSection.vue?vue&type=script&lang=js&"
import style0 from "./PdSection.vue?vue&type=style&index=0&id=8f15443e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f15443e",
  null
  
)

export default component.exports